import { type ReactElement, type ReactNode } from 'react'

import { cn } from '@orus.eu/pharaoh-next/lib/utils'

/**
 * A row of form fields that share the available width and drop to their own line once they would go
 * under 176px, replacing the v1 `FormRow` layout.
 *
 * Deliberately flex rather than an `auto-fit` grid: a grid leaves a field that wrapped alone onto the
 * last line at one column width, where v1 stretched it across the row. That case is reachable here —
 * a three-field row at ~416-608px viewport drops to two columns.
 *
 * pharaoh-next has no form-row primitive yet; this is the first occurrence, so it stays app-level.
 */
export function FormRow({ children, className }: { children: ReactNode; className?: string }): ReactElement {
  return (
    <div
      className={cn(
        `
          flex flex-wrap items-start gap-stack
          [&>*]:max-w-full [&>*]:flex-[1_1_176px]
        `,
        className,
      )}
    >
      {children}
    </div>
  )
}
